<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="上传附件"
      top="5vh"
      width="800px"
      @close="closeDialog">
    <div>
      <upload-file
          ref="upload"
          :show-file-list="false"
          :auth-index="authIndex"
          @upload-success="uploadSuccess"/>
    </div>
    <el-form ref="form" :model="model" :rules="ruleValidate" label-width="90px">
      <el-form-item v-if="model.isCreated" label="图片" prop="imgUrl">
        <!--        <el-input v-model="model.imgPath"/>-->
        <img v-if="model.imgUrl" :src="model.imgUrl" style="height: 100px;width: 100px" @click.self="showBigImage($event)">
      </el-form-item>
      <el-form-item v-if="!model.isCreated" label="图片">
        <!--        <el-input v-model="model.imgPath"/>-->
        <img v-if="model.imgUrl" :src="model.imgUrl" style="height: 100px;width: 100px" @click.self="showBigImage($event)">
      </el-form-item>
      <big-img
          :visible="photoVisible"
          :url="bigImgUrl"
          @closeClick="
            () => {
              photoVisible = false
            }
          "
      />
      <el-form-item label="备注" prop="note">
        <el-input v-model="model.note" type="textarea" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UploadFile from "@/components/UploadFile.vue";
  import BigImg from "@/components/BigImg";
  export default {
    name: "FileUpload",
    components: { UploadFile,BigImg },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        photoVisible:false,
        bigImgUrl:"",
        authIndex: 192,
        model: {
          pkId: 0,
          imgPath: "",
          note: "",
          imgUrl: "",
        },
        ruleValidate: {
          imgUrl: { required:true, message: "请选上传图片", trigger: "blur" },
          note: { required: true, message: "请输入备注", trigger: "blur" },
        },
      };
    },
    mounted() {
      if (this.$route.meta.authIndex) {
        this.authIndex = this.$route.meta.authIndex;
      }
    },
    methods: {
      open(row,index) {
        console.log(row);
        if(row) {
          this.model.isCreated = false;
          this.model.index = index;
          this.model.note = row.note;
        }else{
          this.model.isCreated = true;
        }
        this.dialogVisible = true;
      },

      
      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },
      // 上传成功
      uploadSuccess(fileList) {
        console.log(fileList);
        if (fileList.length) {
          this.getUrl(fileList[0].key);
          this.model.imgPath = fileList[0].key;
          this.model.note = fileList[0].name;
        }
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$emit("save-success",this.model);
            this.dialogVisible = false;
          }
        });
      },
      getUrl(imgPath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(imgPath)}`).then((res) => {
          if (res.success) {
            this.model.imgUrl = res.data;
          }
        });
      },
      closeDialog() {
        this.model.imgPath = "";
        this.model.imgUrl = "";
        this.model.pkId = "";
        this.model.note = "";
      },
    },
  };
</script>
<style lang="scss">
.bom-first {
  border: 1px solid #dddddd;
  height: 120px;
  .bom-message {
    padding: 10px;

    table.bomTable {
      font-family: verdana, arial, sans-serif;
      font-size: 11px;
      color: #333333;
      border-width: 1px;
      border-color: #dddddd;
      border-collapse: collapse;
    }

    table.bomTable th {
      text-align: left;
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
      background-color: #d1e6f5;
    }

    table.bomTable td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
    }

    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #d1e6f5;
    }
  }
}

.bom-seond {
  position: relative;
  margin-top: 1%;
  border: 1px solid #dddddd;
}
</style>
